var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size sm_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("TITLE.ADMIN.EXTENDED.PERIOD")))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "Select_wrap" }, [
              _c("ul", { staticClass: "txt_sel" }, [
                _c("li", { staticClass: "tit" }, [
                  _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.PERIOD")))
                ]),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "w60",
                    attrs: { "data-input-type": "select" }
                  },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchRemainingPeriod,
                            expression: "searchRemainingPeriod"
                          }
                        ],
                        staticClass: "slt_white w100",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.searchRemainingPeriod = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "7" } }, [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.1.WEEK")))
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "30" } }, [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.1.MONTH")))
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "90" } }, [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.3.MONTH")))
                        ])
                      ]
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_modal_wrap topLine" }, [
              _c("div", { staticClass: "btn_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_white",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CANCEL")))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn_blue",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnExtended }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.EXTENDED")))]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-296e9bc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-296e9bc2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/knowledgeManager/expiringKnowledge/popup/ExtendedPeriodPopup.vue
// module id = RYdf
// module chunks = 0